/* vl-lead.js — VL B2B 2026-09-25
 * 1) first-touch attribution cookie (90 days) + URL params -> hidden fields on every Shopify contact form
 * 2) product / SKU prefill from ?product= &sku= (Request-a-quote links)
 * 3) on submit: non-blocking POST to Supabase EF vl-lead-capture (ops_vl_leads, source=form)
 * 4) after successful post (contact_posted=true): fire Google Ads conversion once (send_to from theme settings)
 * 5) price gate on product pages (variants > threshold: hide price, show "Request a quote")
 * Config comes from <script type="application/json" id="vl-b2b-config"> rendered by layout/theme.liquid (theme settings).
 */
(function () {
  'use strict';
  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('vl-b2b-config') || {}).textContent || '{}'); } catch (e) { CFG = {}; }
  var KEYS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var CK = 'vl_ft';
  function getCookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function setCookie(n, v, days) { document.cookie = n + '=' + encodeURIComponent(v) + ';path=/;max-age=' + days * 86400 + ';SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : ''); }
  var qs = new URLSearchParams(location.search);
  var ft = {};
  try { ft = JSON.parse(getCookie(CK) || '{}') || {}; } catch (e) { ft = {}; }
  var fromUrl = {}; var hasUrl = false;
  KEYS.forEach(function (k) { var v = qs.get(k); if (v) { fromUrl[k] = v.slice(0, 300); hasUrl = true; } });
  if (!ft.landing_page) {
    ft = Object.assign({}, fromUrl, { landing_page: (location.pathname + location.search).slice(0, 500), ts: Date.now() });
    setCookie(CK, JSON.stringify(ft), 90);
  } else if (hasUrl) {
    // keep first touch, but add click ids that the first touch did not have (e.g. later ad click)
    var changed = false;
    KEYS.forEach(function (k) { if (fromUrl[k] && !ft[k]) { ft[k] = fromUrl[k]; changed = true; } });
    if (changed) setCookie(CK, JSON.stringify(ft), 90);
  }
  function attr(k) { return fromUrl[k] || ft[k] || ''; }

  function isContactForm(f) { var t = f.querySelector('input[name="form_type"]'); return t && t.value === 'contact'; }
  function ensureHidden(f, name, val) {
    var el = f.querySelector('input[name="' + name + '"]');
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = name; f.appendChild(el); }
    if (val && !el.value) el.value = val;
    return el;
  }
  function prodParam() {
    var p = qs.get('product') || ''; var s = qs.get('sku') || '';
    return (p + (s ? ' (SKU ' + s + ')' : '')).slice(0, 300);
  }
  function fillForms() {
    var forms = document.querySelectorAll('form');
    Array.prototype.forEach.call(forms, function (f) {
      if (!isContactForm(f)) return;
      KEYS.forEach(function (k) { ensureHidden(f, 'contact[' + k + ']', attr(k)); });
      ensureHidden(f, 'contact[landing_page]', ft.landing_page || '');
      var pp = prodParam(); var pe = ensureHidden(f, 'contact[product]', pp);
      if (pp && pe.value !== pp && !f.hasAttribute('data-vl-product-fixed')) pe.value = pp;
      var vis = f.querySelector('[data-vl-product-visible]'); if (vis && pp && !vis.value) vis.value = pp;
      if (!f.__vlBound) { f.__vlBound = true; f.addEventListener('submit', onSubmit); }
    });
  }
  function val(f, n) { var el = f.querySelector('[name="' + n + '"]'); return el ? String(el.value || '').trim() : ''; }
  function onSubmit(ev) {
    var f = ev.currentTarget;
    try {
      var hp = f.querySelector('input[name="vl_hp"]');
      var email = val(f, 'contact[email]');
      var pending = { email: email, t: Date.now() };
      try { sessionStorage.setItem('vl_lead_pending', JSON.stringify(pending)); } catch (e) {}
      if (!CFG.ef || !email) return;
      var body = {
        email: email, name: val(f, 'contact[name]'), company: val(f, 'contact[company]'), phone: val(f, 'contact[phone]'),
        country: val(f, 'contact[country]'), buyer_type: val(f, 'contact[buyer_type]'), product: val(f, 'contact[product]') || val(f, 'contact[product_list]'),
        quantity: val(f, 'contact[quantity]'), target_price: val(f, 'contact[target_price]'), needed_by: val(f, 'contact[needed_by]'),
        landing_page: val(f, 'contact[landing_page]'), request_type: val(f, 'contact[request_type]'), destination: val(f, 'contact[destination]'), page: location.pathname + location.search,
        hp: hp ? hp.value : '', is_test: qs.get('vl_test') === '1'
      };
      KEYS.forEach(function (k) { body[k] = val(f, 'contact[' + k + ']'); });
      var data = JSON.stringify(body);
      // keepalive fetch survives the native form navigation; failures are ignored (never block the form)
      fetch(CFG.ef, { method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: data }).catch(function () {});
    } catch (e) { /* never block native submit */ }
  }

  function fireConversion() {
    /* 1010 广告AI:只认联系表单的成功——博客评论 / 找回密码等成功提示(.form__message--success)不再误记为询盘 */
    var posted = /[?&]contact_posted=true/.test(location.search) || !!document.querySelector('.vl-q__ok') ||
      Array.prototype.some.call(document.querySelectorAll('.form__message--success, .form-status--success, .contact-form__success, .form-message--success'),
        function (el) { var f = el.closest('form'); return !!(f && isContactForm(f)); });
    if (!posted || !CFG.sendTo) return;
    var pend = null; try { pend = JSON.parse(sessionStorage.getItem('vl_lead_pending') || 'null'); } catch (e) {}
    var key = 'vl_conv_' + (pend ? pend.t : location.pathname);
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); sessionStorage.removeItem('vl_lead_pending'); } catch (e) {}
    var go = function () {
      if (typeof window.gtag !== 'function') return;
      if (pend && pend.email) { try { window.gtag('set', 'user_data', { email: pend.email }); } catch (e) {} }
      window.gtag('event', 'conversion', { send_to: CFG.sendTo, value: Number(CFG.value || 0) || 100, currency: 'USD', transaction_id: 'vlq-' + (pend ? pend.t : Date.now()) });
      window.gtag('event', 'generate_lead', { currency: 'USD', value: Number(CFG.value || 0) || 100 });
    };
    if (typeof window.gtag === 'function') go(); else window.addEventListener('load', go);
  }

  // ---- price gate (product page) ----
  function priceGate() {
    var el = document.getElementById('vl-price-gate'); if (!el) return;
    var pg = {}; try { pg = JSON.parse(el.textContent || '{}'); } catch (e) { return; }
    var hidden = pg.hidden || {};
    function currentVariant() {
      var u = new URLSearchParams(location.search).get('variant');
      if (u) return u;
      var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return inp ? String(inp.value) : String(pg.first || '');
    }
    function apply() {
      var h = !!hidden[currentVariant()];
      document.documentElement.classList.toggle('vl-price-hidden', h);
    }
    apply();
    document.addEventListener('change', function () { setTimeout(apply, 60); }, true);
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.swatch, [data-value], .variant-input, label')) setTimeout(apply, 120); }, true);
    var last = location.search; setInterval(function () { if (location.search !== last) { last = location.search; apply(); } }, 400);
  }

  // Request-a-quote buttons on product pages scroll to the inline form and prefill it
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-vl-quote]');
    if (!a) return;
    var target = document.getElementById('vl-quote');
    if (!target) return; // no inline form: follow link to quote page (prefilled via ?product=)
    e.preventDefault();
    var pe = target.querySelector('[data-vl-product-visible]');
    if (pe && a.getAttribute('data-product')) pe.value = a.getAttribute('data-product');
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var first = target.querySelector('input:not([type=hidden])'); if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (x) {} }, 500);
  });

  function init() { fillForms(); fireConversion(); priceGate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', fillForms);
})();
